import { Pipe, PipeTransform } from '@angular/core';
import { RelationshipStatus } from '../../../models/enum/shared/relationship-status';
import { RelationshipStatusUtils } from '../../../utils/relationship-status-utils';

@Pipe({
  name: 'relationshipStatusFileUploadCopy'
})
export class RelationshipStatusFileUploadCopyPipe implements PipeTransform {
  transform(value: RelationshipStatus): string {
    return RelationshipStatusUtils.getRelationshipFileUploadCopy(value);
  }
}
